import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { eventService, getPage, XApiEventKeys } from 'shared/api/event-service';

import { SEE_ALL_ROUTES } from './constants';
import styles from './styles.module.scss';

export type SeeAllButtonProps = {
  navigateTo: SEE_ALL_ROUTES;
  sectionName: SEE_ALL_ROUTES;
  classNames?: string;
};

export const SeeAllButton = ({
  navigateTo,
  sectionName,
  classNames,
}: SeeAllButtonProps) => {
  const { t } = useTranslation();

  const handleXApiEvents = (isRightClick: boolean) => {
    eventService.send(XApiEventKeys.seeAllButtonSelected, undefined, {
      result: {
        url: window.location.href,
        page: getPage(),
        section: sectionName,
        isRightClick,
      },
    });
  };

  const handleClick = () => handleXApiEvents(false);

  const handleContextMenu = () => handleXApiEvents(true);

  return (
    <div>
      <Link
        to={navigateTo}
        type="button"
        className={clsx(
          'btn btn-oval see-all-btn',
          styles.seeAllBtn,
          classNames,
        )}
        onClick={handleClick}
        onContextMenu={handleContextMenu}
        data-testid="see-all-button"
      >
        {t('See All')}
      </Link>
    </div>
  );
};
